import { render, staticRenderFns } from "./BillingAddressTab.vue?vue&type=template&id=1635ed06&"
import script from "./BillingAddressTab.vue?vue&type=script&lang=js&"
export * from "./BillingAddressTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports